import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { FaPlus, FaEdit, FaTrash } from 'react-icons/fa';
import Pagination from '../Common/Pagination';

const AdminCustomers = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const token = localStorage.getItem('adminToken');

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await axios.get(
          `/api/admin/customers?pageNumber=${page}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setCustomers(response.data.customers);
        setPages(response.data.pages);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching customers:', error);
        setLoading(false);
      }
    };

    fetchCustomers();
  }, [page, token]);

  const deleteCustomer = async (id) => {
    if (window.confirm('Are you sure you want to delete this customer?')) {
      try {
        await axios.delete(`/api/admin/customers/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCustomers(customers.filter((customer) => customer._id !== id));
      } catch (error) {
        console.error('Error deleting customer:', error);
      }
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h1 className='text-3xl font-bold mb-8'>Manage Customers</h1>
      <Link
        to='/admin/customers/create'
        className='inline-block bg-blue-500 text-white py-2 px-4 rounded mb-8'
      >
        <FaPlus className='mr-2 inline' /> Add Customer
      </Link>
      <table className='w-full text-left'>
        <thead>
          <tr>
            <th className='p-4 border-b'>Name</th>
            <th className='p-4 border-b'>Email</th>
            <th className='p-4 border-b'>Phone</th>
            <th className='p-4 border-b'>Actions</th>
          </tr>
        </thead>
        <tbody>
          {customers?.map((customer) => (
            <tr key={customer._id}>
              <td className='p-4 border-b'>{customer.name}</td>
              <td className='p-4 border-b'>{customer.email}</td>
              <td className='p-4 border-b'>{customer.phoneNumber}</td>
              <td className='p-4 border-b flex'>
                <Link
                  to={`/admin/customers/${customer._id}/edit`}
                  className='mr-4 text-blue-500'
                >
                  <FaEdit />
                </Link>
                <button
                  onClick={() => deleteCustomer(customer._id)}
                  className='text-red-500'
                >
                  <FaTrash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination
        page={page}
        pages={pages}
        onChangePage={(newPage) => setPage(newPage)}
      />
    </div>
  );
};

export default AdminCustomers;
